import {debounce} from '@github/mini-throttle'
import {announce} from '@github-ui/aria-live'
import {SearchIcon} from '@primer/octicons-react'
import {TextInput} from '@primer/react'
import {Blankslate} from '@primer/react/experimental'
import {type PropsWithChildren, useEffect} from 'react'

const debounceAnnouncement = debounce(announce, 300)

export function PropertiesValuesForm({children}: PropsWithChildren) {
  return (
    <form data-testid="properties-editing-form" className="d-flex flex-column gap-3">
      {children}
    </form>
  )
}

PropertiesValuesForm.Filter = Filter
PropertiesValuesForm.EmptyState = EmptyState
PropertiesValuesForm.ActionsContainer = ActionsContainer

interface FilterProps {
  value: string
  onChange: (value: string) => void
  // The definitions count will be announced to screen reader users
  definitionsCount: number
}
function Filter({definitionsCount, value, onChange}: FilterProps) {
  useEffect(() => {
    if (definitionsCount === 1) {
      debounceAnnouncement('1 result found')
    } else {
      debounceAnnouncement(`${definitionsCount} results found`)
    }
  }, [definitionsCount])

  return (
    <TextInput
      block
      leadingVisual={SearchIcon}
      placeholder="Filter properties"
      aria-label="Filter properties"
      value={value}
      onChange={e => onChange(e.target.value)}
    />
  )
}

function EmptyState() {
  return (
    <Blankslate border>
      <Blankslate.Heading>No properties that match</Blankslate.Heading>
    </Blankslate>
  )
}

function ActionsContainer({children}: PropsWithChildren) {
  return <div className="d-flex gap-2">{children}</div>
}

try{ PropertiesValuesForm.displayName ||= 'PropertiesValuesForm' } catch {}
try{ Filter.displayName ||= 'Filter' } catch {}
try{ EmptyState.displayName ||= 'EmptyState' } catch {}
try{ ActionsContainer.displayName ||= 'ActionsContainer' } catch {}